$(function () {
    $("#before-you-rent-btn").on("mouseover", function () {
        $("#before-you-rent-btn img").attr(
            "src",
            "/app/images/izanau/index/before-rent/bulb-white.png"
        );
        $(".before-you-rent-btn-container").addClass("active");
    });
    $("#before-you-rent-btn").on("mouseout", function () {
        $("#before-you-rent-btn img").attr(
            "src",
            "/app/images/izanau/index/before-rent/bulb-orange.png"
        );
        $(".before-you-rent-btn-container").removeClass("active");
    });

    $("#modal-before-you-rent").on("shown.bs.modal", function () {
        $("#before-you-rent-btn").trigger("mouseover");
    });

    $("#modal-before-you-rent").on("hide.bs.modal", function () {
        $("#before-you-rent-btn").trigger("mouseout");
    });

    $("#before-you-rent-folder .tab").on("click", function () {
        $("#before-you-rent-folder .tab").removeClass("active");
        $(this).addClass("active");

        let tab_group_id = $(this).attr("id");
        let content_group_id =
            "#content-group-rent-id-" +
            tab_group_id.replace("group-rent-tab-", "");
        $("#before-you-rent-folder .content").removeClass("active");
        $(content_group_id).addClass("active");
    });
});
